import axios from "axios";
import { store } from "../Redux/store";
import endpoints from "../Config/endpoints";

const fetchClient = (key = null) => {
  const defaultOptions = {
    headers: {
      "x-api-key": key,
      "Content-Type": "application/json",
    },
  };
  
  let instance = axios.create(defaultOptions);
  return instance;
};

// Special client for GraphQL endpoints with environment variable API key
const fetchGraphQLClient = (key = null) => {
  const defaultOptions = {
    headers: {
      "x-api-key": process.env.REACT_APP_GRAPHQL_API_KEY, // Using environment variable instead of hardcoded key
      "Content-Type": "application/json",
    },
  };
  
  let instance = axios.create(defaultOptions);
  return instance;
};

const API = {
  get: async (key = null, path) => {
    try {
      // Check if the path is a GraphQL endpoint
      if (path === endpoints.graphql) {
        return await fetchGraphQLClient(key).get(path);
      }
      
      return await fetchClient(key).get(path);
    } catch (error) {
      console.log("error", error);
      return { status: error?.response?.status, data: error?.response?.data };
    }
  },
  post: async (key = null, path, params) => {
    try {
      // Check if the path is a GraphQL endpoint
      if (path === endpoints.graphql) {
        return await fetchGraphQLClient(key).post(path, params);
      }
      
      return await fetchClient(key).post(path, params);
    } catch (error) {
      return { status: error?.response?.status, data: error?.response?.data };
    }
  },
  put: async (key = null, path, params) => {
    try {
      return await fetchClient(key).put(path, params);
    } catch (error) {
      return { status: error?.response?.status, data: error?.response?.data };
    }
  },
  delete: async (key = null, path) => {
    try {
      return await fetchClient(key).delete(path);
    } catch (error) {
      return { status: error?.response?.status, data: error?.response?.data };
    }
  },
};

export default API;